<form #formLogin="ngForm" *ngIf="appCopy && appCopy.panelHeader && copyLoaded " name="formLogin"
  (submit)="handleSubmitOTP(formLogin.value, $event)" novalidate>
  <h3 class="page__heading text-dark-blue margin-bottom-24">
    {{ appCopy.panelHeader["title" + selectedLanguage] }}
  </h3>

  <div class="panel">
    <div class="panel__header">{{ appCopy.panelHeader["description" + selectedLanguage] }}</div>
    <div class="panel__body">
      <div class="section">
        <p class="text-muted text-dark-blue">{{ appCopy.panelHeader["heading" + selectedLanguage] }}</p>
      </div>
      <div class="section section__colored">
        <div class="form-group">
          <input class="form-control" [ngClass]="{ 'has-error': email.invalid && email.dirty }" id="email" name="email"
            type="email" #email="ngModel" [ngModel]="userEmail" [pattern]="emailPattern" ngModel required appCheckEmpty
            [placeholder]="appCopy.panelHeader['emailPlaceholder' + selectedLanguage]" readonly />
          <i class="icon control-validation-state"></i>

          <p class="help-block text-danger" *ngIf="email?.errors?.pattern">
            {{ appCopy.panelHeader["validEmail" + selectedLanguage] }}
          </p>
          <p class="help-block text-danger" *ngIf="email.invalid && email.dirty && !email?.errors?.pattern">
            {{ appCopy.panelHeader["warningEmail" + selectedLanguage] }}
          </p>
        </div>

        <div class="form-group margin-top-16">
          <input class="form-control" [ngClass]="{ 'has-error': otp.invalid && otp.dirty }" id="Otp" name="otp"
            type="otp" #otp="ngModel" ngModel alert-caps-lock required appCheckEmpty maxlength="6" pattern="\d{6}"
            [placeholder]="appCopy.panelHeader['OTPPlaceholder' + selectedLanguage]" />
          <i class="icon control-validation-state"></i>

          <p class="help-block text-danger" *ngIf="otp.invalid && otp.dirty && !otp?.errors?.pattern">
            {{ appCopy.panelHeader["warningOTP" + selectedLanguage] }}
          </p>

          <p class="help-block text-danger" *ngIf="otp?.errors?.pattern">
            {{ appCopy.panelHeader["validOTP" + selectedLanguage] }}
          </p>
        </div>
      </div>
      <div class="section section__actions flex flex--justify-content-center text-center gap-16">
        <button type="submit" class="btn btn-purple btn-lg" [disabled]="formLogin.invalid">
          <div class="loader-container-btn" *ngIf="showLoader">
            <div class="loader loader--white">
              <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" />
              </svg>
            </div>
          </div>
          {{ appCopy.panelHeader["submitOTPButton" + selectedLanguage] }}
        </button>

        <div style="display: flex;gap:16px;justify-content: space-between;">
          <button (click)="resendEmail($event)" class="btn btn-primary btn-ghost btn-lg" [disabled]="
            showLoader ||
            isCounting ||
            (email.invalid && email.dirty && !email?.errors?.pattern)
          ">
            {{ isCounting ? appCopy.panelHeader['resendInSecText'+selectedLanguage].replace('%s', countdown) :
            appCopy.panelHeader['resendOTPButton'+selectedLanguage] }}
          </button>

          <button *ngIf="is2FARequired" (click)="toggleChannel($event)" class="btn btn-primary btn-ghost btn-lg"
            [disabled]="
            showLoader ||
            isCounting ||
            (email.invalid && email.dirty && !email?.errors?.pattern)
          ">
            {{ channel === 'Sms' ? appCopy.panelHeader['buttonResendWhatsApp'+selectedLanguage] :
            appCopy.panelHeader['ButtonResendSms'+selectedLanguage] }}
          </button>
        </div>

      </div>
    </div>
  </div>
</form>
<app-notifications></app-notifications>